export function toKebabCase(s: string): string {
	return s
		.replace(/([A-Z])/g, "-$1")
		.toLowerCase()
		.replace(/^-/, "");
}

/** A domain value ("Registered Nurse (RN)", "2ND FLOOR - 2A") as a stable kebab-case test-id segment. */
export function toTestIdSlug(value: string): string {
	return value
		.toLowerCase()
		.replace(/[^a-z0-9]+/g, "-")
		.replace(/^-+|-+$/g, "");
}

export function toPascalCase(s: string): string {
	return s
		.split("-")
		.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
		.join("");
}

/** "Megan Vega" → "Megan V." so a full, identifiable name fits a narrow column (keep the full name in a tooltip). */
export function firstNameLastInitial(name: string): string {
	const parts = name.trim().split(/\s+/);
	if (parts.length < 2) return name;
	return `${parts[0]} ${parts[parts.length - 1][0]}.`;
}
